import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { spApi } from '@/lib/api-client';
import { invalidateVendorQueries } from './use-payees';
import { useLocationStore } from '@/stores/location-store';

export function useSpPayees(params: Record<string, string | number | boolean | undefined> = {}) {
  // Auto-scope to the active location — vendors that don't do business at
  // the current location are filtered out (server side via product_payees).
  const selectedLocationId = useLocationStore((s) => s.selectedLocationId);
  const scopedParams =
    params.locationId === undefined && selectedLocationId ? { ...params, locationId: selectedLocationId } : params;
  return useQuery({
    queryKey: ['sp-payees', scopedParams],
    queryFn: () => spApi.get<{ data: any[] }>('/payees', scopedParams),
  });
}

export function useCreateSpPayee() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => spApi.post('/payees', data),
    onSuccess: () => invalidateVendorQueries(queryClient),
  });
}
